import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HelperService } from '../helper.service';
import { CURRENCY } from '../../environments/environment';
import {
  RATE_TYPE_FIXED, RATE_TYPE_PER_MONTH,
  RATE_TYPE_FREE, RATE_TYPE_PER_CLASS, RATE_TYPE_PER_HOUR, LOGIN_APPLE_STORE_LINK, LOGIN_PLAYSTORE_LINK

} from 'src/app/constants';
import {
  SEARCH_RESULT_KEYWORDS, SEARCH_RESULT_KEYWORD_CONTENT,
  SEARCH_RESULT_KEYWORD_DESC, SEARCH_RESULT_KEYWORD_DESC_CONTENT, SEARCH_TITLE
} from 'src/app/seoconstants';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Title, Meta } from '@angular/platform-browser';

import { IBusinessDetail } from '../interface'

interface ICategoryPackages { category: any, packages: IBusinessDetail[] }
interface ICategoryPackagesMap { [key: number]: ICategoryPackages}

@Component({
  selector: 'app-class-search-details',
  templateUrl: './class-search-details.component.html',
  styleUrls: ['./class-search-details.component.scss']
})
export class ClassSearchDetailsComponent implements OnInit {
  active = 1;
  scheduleID: string;
  pkgID: string;
  courseStatus: string;
  courseDetails: any;
  course_schedule: any = [];
  faculty: any;
  package_contents: any;
  vendorType: string;
  vendorTypeList: any[];
  vendorTypeName: string;
  vendorTypeId: string;
  vendorTypes: number;
  specialityList: any;
  speciality: string;
  specialityName: string;
  ageGroup: string;
  batchName: string;
  occuranceType: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  numberOfHours: string;
  priceRateTypeName: string;
  whatsappURL: string;
  deliveryMode: string;
  instructionChannel: string;
  joining: string;
  courseName: string;
  lowPrice: any;
  highPrice: any;
  registrationCharges: string;
  userID: string;
  description: string;
  package_features: [];
  businessName: string;
  vendorID: string;
  currency: string;
  courseID: string;
  category: string;
  priceRateTypeId: any;
  businessDetailsList: [];
  contactNo: string;
  whatsAppno: string;
  profileDesc: string;
  experience: string;
  qualification: string;
  isTeacher: number;
  addressLineOne: string;
  addressLineTwo: string;
  country: string;
  countryState: string;
  postalCode: string;
  town: string;
  venGroupTypes: string;
  vendor_classes: any;
  socialmedia: string;
  vendorClasses: any;
  facebookpage: string;
  linkedinpage: string;
  instapage: string;
  twitterPage: string;
  closeResult: string;
  hostID: string;
  token_data: string;
  userEmail: string;
  password: string;
  verifiedStatus: string;
  errormsg: string;
  appleLink: string;
  playstoreLink: string;
  title: string;
  keywords: string;
  keywordcontent: string;
  desc: string;
  desccontent: string;

  otherClassesAvailable: ICategoryPackages[] = []

  teacherImage = 'assets/images/new/user.webp'

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService: HelperService,
    private modalService: NgbModal,
    private titleService: Title, private metaService: Meta
  ) {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };


    this.vendorID = this.activatedRoute.snapshot.paramMap.get('venId');
    this.pkgID = this.activatedRoute.snapshot.paramMap.get('id');
    this.category = this.activatedRoute.snapshot.paramMap.get('category');

  }

  ngOnInit() {

    this.currency = CURRENCY;

    this.appleLink = LOGIN_APPLE_STORE_LINK;
    this.playstoreLink = LOGIN_PLAYSTORE_LINK;

    this.title = SEARCH_TITLE;
    //this.keywords = SEARCH_RESULT_KEYWORDS;
    //this.keywordcontent = SEARCH_RESULT_KEYWORD_CONTENT;
    //this.desc = SEARCH_RESULT_KEYWORD_DESC;
    //this.desccontent = SEARCH_RESULT_KEYWORD_DESC_CONTENT;

    this.currency = CURRENCY;

    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      { name: this.keywords, content: this.description },
      { name: this.description, content: this.description },
      { name: 'robots', content: 'index, follow' }
    ]);



    let packageData = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      //userID: this.helperService.studented_atob(this.helperService.getUserID()),
      //hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      courseID: this.pkgID,
      scheduleID: this.vendorID,
      pkgID: this.pkgID
    }

    this.apiService.packageDetails(packageData).subscribe((res: any) => {
      this.courseDetails = res.data.vendorPkg.data.courseDetails[0];
      this.course_schedule = res.data.vendorPkg.data.course_schedule;
      this.faculty = res.data.vendorPkg.data.faculty;
      this.package_contents = res.data.vendorPkg.data.package_contents;

      this.getVendorType();
      this.getSpecilityType();


      this.vendorTypes = res.data.vendorPkg.data.courseDetails[0].vendorTypes;

      this.speciality = res.data.vendorPkg.data.courseDetails[0].speciality;
      this.ageGroup = res.data.vendorPkg.data.courseDetails[0].ageGroup;

      this.courseName = res.data.vendorPkg.data.courseDetails[0].packageName;
      this.courseID = res.data.vendorPkg.data.courseDetails[0].id;
      this.lowPrice = res.data.vendorPkg.data.courseDetails[0].lowPrice;
      this.highPrice = res.data.vendorPkg.data.courseDetails[0].highPrice;
      this.registrationCharges = res.data.vendorPkg.data.courseDetails[0].registrationCharges;
      this.courseStatus = res.data.vendorPkg.data.courseDetails[0].status;
      this.description = res.data.vendorPkg.data.courseDetails[0].description;
      this.businessName = res.data.vendorPkg.data.courseDetails[0].businessName;
      this.priceRateTypeId = res.data.vendorPkg.data.courseDetails[0].priceRateTypeId;

      if (this.batchName) {
        this.batchName = res.data.vendorPkg.data.course_schedule[0].batchName;
      }
      if (this.occuranceType) {
        this.occuranceType = res.data.vendorPkg.data.course_schedule[0].occuranceType;
      }
      if (this.startDate) {
        this.startDate = res.data.vendorPkg.data.course_schedule[0].startDate;
      }
      if (this.endDate) {
        this.endDate = res.data.vendorPkg.data.course_schedule[0].endDate;
      }
      if (this.startTime) {
        this.startTime = res.data.vendorPkg.data.course_schedule[0].startTime;
      }
      if (this.endTime) {
        this.endTime = res.data.vendorPkg.data.course_schedule[0].endTime;
      }
      if (this.numberOfHours) {
        this.numberOfHours = res.data.vendorPkg.data.course_schedule[0].numberOfHours;
      }
      if (this.priceRateTypeName) {
        this.priceRateTypeName = res.data.vendorPkg.data.course_schedule[0].priceRateTypeName;
      }
      if (this.whatsappURL) {
        this.whatsappURL = res.data.vendorPkg.data.course_schedule[0].whatsappURL;
      }
      if (this.deliveryMode) {
        this.deliveryMode = res.data.vendorPkg.data.course_schedule[0].deliveryMode;
      }
      if (this.instructionChannel) {
        this.instructionChannel = res.data.vendorPkg.data.course_schedule[0].instructionChannel;
      }
      if (this.joining) {
        this.joining = res.data.vendorPkg.data.course_schedule[0].joining;
      }

      this.userID = this.helperService.studented_atob(this.helperService.getUserID());

      this.package_features = res.data.vendorPkg.data.package_features;
      this.package_contents = res.data.vendorPkg.data.package_contents;

      let businessdata = {
        //token:this.helperService.studented_atob(this.helperService.getToken()),
        userID: this.helperService.studented_atob(this.helperService.getUserID()),
        vendorID: this.vendorID
      }

      this.apiService.businessDetails(businessdata).subscribe((res: any) => {
        this.businessDetailsList = res.data.vendorBusinessDetails.data;
        this.deliveryMode = res.data.vendorBusinessDetails.data.deliveryMode;

        this.contactNo = res.data.vendorBusinessDetails.data.venPhoneNumber;
        this.whatsAppno = res.data.vendorBusinessDetails.data.venAlternatePhoneNumber;
        this.profileDesc = res.data.vendorBusinessDetails.data.profileDescription;
        this.experience = res.data.vendorBusinessDetails.data.experience;
        this.qualification = res.data.vendorBusinessDetails.data.qualification;
        this.businessName = res.data.vendorBusinessDetails.data.businessName;
        this.vendor_classes = res.data.vendorBusinessDetails.data.vendor_classes;

        this.isTeacher = res.data.vendorBusinessDetails.data.isTeacher;
        this.addressLineOne = res.data.vendorBusinessDetails.data.address.addressLineOne;
        this.addressLineTwo = res.data.vendorBusinessDetails.data.address.addressLineTwo;
        this.addressLineTwo = res.data.vendorBusinessDetails.data.address.addressLineTwo;
        this.country = res.data.vendorBusinessDetails.data.address.country;
        this.countryState = res.data.vendorBusinessDetails.data.address.countryState;
        this.postalCode = res.data.vendorBusinessDetails.data.address.postalCode;
        this.town = res.data.vendorBusinessDetails.data.address.town;

        this.venGroupTypes = this.helperService.groupBy(res.data.vendorBusinessDetails.data.vendor_type_specialities, 'vendorTypeName');
        this.facebookpage = res.data.vendorBusinessDetails.data.facebookPage;
        this.linkedinpage = res.data.vendorBusinessDetails.data.linkedInPage;
        this.instapage = res.data.vendorBusinessDetails.data.instagramPage;
        this.twitterPage = res.data.vendorBusinessDetails.data.twitterPage;
        
        if (res.data.vendorBusinessDetails.data.vendor_images.length > 0) {
          this.teacherImage = res.data.vendorBusinessDetails.data.vendor_images[0].imageURL;
        }

        if (this.vendor_classes) {
          let venClasses = [];
          for (const key in this.vendor_classes) {
            if (this.vendor_classes.hasOwnProperty(key)) {
              const element = this.vendor_classes[key];
              venClasses.push(element.className)
            }
          }
          this.vendorClasses = venClasses.join(' | ');
        }


        const allPackages = res.data.vendorBusinessDetails.data.packages as any[];
        const categoryPackages: ICategoryPackagesMap = {} as ICategoryPackagesMap
        allPackages
          .filter(el => el.id != this.pkgID)
          .forEach(el => {
            console.log('[el] : ', el);
            console.log('[categoryPackages] : ', categoryPackages);
            
            const pack: IBusinessDetail = { ...el, venId: this.vendorID, imageURL: el.package_images[0], businessName: this.businessName }

            if (categoryPackages.hasOwnProperty(el.vendorTypes)) {
              categoryPackages[el.vendorTypes].packages.push(pack)
            } else {
              categoryPackages[el.vendorTypes] = { category: this.vendorTypeList.find(i => i.id === el.vendorTypes) } as ICategoryPackages
              categoryPackages[el.vendorTypes].packages = [pack]
            }

            
          })

        this.otherClassesAvailable = Object.values(categoryPackages);

        console.log('[ICategoryPackagesMap] : ', this.otherClassesAvailable);
        


      }, async err => {

      })



    }, async err => {

    })




  }



  getVendorType() {

    let vendorTypeData = {
      // token:this.helperService.studented_atob(this.helperService.getToken()),
      //  userID: this.helperService.studented_atob(this.helperService.getUserID()),
      // hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      courseID: this.pkgID,
      scheduleID: this.vendorID,
      pkgID: this.pkgID
    }

    this.apiService.getVenDetails(vendorTypeData).subscribe((res: any) => {
      this.vendorTypeList = res.data.venDetails.data;
      this.vendorTypeList.forEach(obj => {
        if (this.vendorTypes == obj.id) {
          this.vendorTypeName = obj.vendorTypeName;


        }

      })

    }, async err => {

    })

  }

  getSpecilityType() {
    let specialityData = {
      // token:this.helperService.studented_atob(this.helperService.getToken()),
      // userID: this.helperService.studented_atob(this.helperService.getUserID()),
      //  hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      courseID: this.pkgID,
      scheduleID: this.vendorID,
      pkgID: this.pkgID
    }
    this.apiService.getSpecialityData(specialityData).subscribe((res: any) => {

      this.specialityList = res.data.specialityData.data;
      this.specialityList.forEach(obj1 => {
        if (this.speciality == obj1.id) {
          this.specialityName = obj1.specialityName;
        }

      })
    })


  }

  makeEnrollment(vendorID, courseID) {
    this.userID = this.helperService.getUserID();
    if (this.userID == "") {
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`create-enrollment/` + vendorID + `/` + courseID, { skipLocationChange: true });
    }


  }
  InstituteDetails(vendorID) {
    this.router.navigateByUrl(`profile/` + vendorID);
  }

  getRateText(priceRateTypeId) {
    if (!priceRateTypeId) {
      return "";
    }

    if (priceRateTypeId === 1) {
      return RATE_TYPE_FIXED;
    } else if (priceRateTypeId === 2) {
      return RATE_TYPE_PER_MONTH;
    }
    else if (priceRateTypeId === 3) {
      return RATE_TYPE_FREE;
    }
    else if (priceRateTypeId === 4) {
      return RATE_TYPE_PER_CLASS;
    }
    else
      return RATE_TYPE_PER_HOUR;
  }

  request(vendorID, courseID) {


    //this.userID = this.helperService.getUserID();
    this.userID = this.helperService.studented_atob(this.helperService.getUserID());
    console.log(this.userID);

    if (this.userID == "") {
      //this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`create-enquiry/` + vendorID + `/` + courseID);
    }

  }

  open(content) {
    this.modalService.open(content, { centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onLogin() {
    //console.log("hello xxxx");
    let hostData =
    {
      userEmail: this.userEmail,
      password: this.password
    }

    this.apiService.hostLogin(hostData).subscribe(async (res: any) => {
      this.hostID = res.data.hostID;
      this.token_data = res.data.token_data;
      this.userID = res.data.userID;

      this.helperService.setToken(this.helperService.studented_btoa(this.token_data));
      this.helperService.setUserID(this.helperService.studented_btoa(this.userID));
      this.helperService.setHostID(this.helperService.studented_btoa(this.hostID));
      //localStorage.setItem("userID", this.userID);
      let userdata = {
        //token:this.helperService.studented_atob(this.helperService.getToken()) ,
        userID: this.helperService.studented_atob(this.helperService.getUserID())
      }

      this.apiService.checkUser(userdata).subscribe(async (res: any) => {
        this.userID = res.data.userStatus.data.id;
        this.verifiedStatus = res.data.userStatus.data.verifiedStatus;

      }, async err => {

      })
      this.modalService.dismissAll();
      this.router.navigateByUrl(`create-enquiry/` + this.vendorID + `/` + this.pkgID, { skipLocationChange: true });
      //alert("Successful Login");
    }, async err => {

      this.errormsg = err.error.meta.msg;
      alert(this.errormsg);

      return;


    })

  }
  register() {
    this.modalService.dismissAll();
    this.router.navigateByUrl(`register`);
  }

  getPartyTime(startTime, endTime) {
    if (!startTime || !endTime) {
      return "";
    }
    return (
      this.helperService.timeFormat1(startTime) +
      " - " +
      this.helperService.timeFormat1(endTime)
    );
  }

}
